import React from 'react';
import {LoaderFullScreenProps} from "../../@types/screen";

const LoaderFullScreen: React.FC<LoaderFullScreenProps> = ({ message }) => {
  return (
      <div className="w-full h-full fixed top-0 left-0 bg-white bg-opacity-50 backdrop-blur-md z-[999]">
        <div className="flex flex-col gap-4 justify-center items-center mt-[50vh]">
          <div
              className="h-24 w-24 rounded-full border-t-8 border-b-8 border-fred-blue-500 animate-spin">
          </div>
          <p className="font-medium text-lg">{message ? message : 'Loading...'}</p>
        </div>
      </div>
  );
};

export default LoaderFullScreen;
